import { useEffect, useState } from 'react';

import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { ReferentialType } from '../../../../_constants/referentialType';
import SelectCreatableHookForm from '../../../../common/components/SelectCreatableHookForm';
import { IReferential } from '../../../referential/reducers';
import { RightType } from '../../enums';
import { formTypeText, ModalTeamMemberFormProps } from '../../props/ModalTeamMemberFormProps';
import { defaultTeamMemberAvailability } from '../../props/MyTeamComponentProps';
import { ITeamMember, ITeamMemberAvailability, ITeamMemberRight } from '../../reducers';

const ModalTeamMemberForm = (props: ModalTeamMemberFormProps) => {
  const { actionRequest, reloadTeam, show, setShow, type } = props;

  type FormValues = {
    firstname: string;
    name: string;
    email: string;
    phoneNumber: string;
    activityDone?: IReferential;
    activityTime?: IReferential;
    isAvailable?: boolean;
    RCAF?: boolean;
    RAAC?: boolean;
    RUR?: boolean;
    RANR?: boolean;
  };

  const defaultValues: FormValues = {
    firstname: props.teamMember.user.firstname,
    name: props.teamMember.user.lastname,
    email: props.teamMember.user.email,
    phoneNumber: props.teamMember.user.phoneNumber,
    activityDone: props.teamMember.user.userInfos.activityDone,
    activityTime: props.teamMember.user.userInfos.activityTime,
    RCAF: !!props.teamMember.rights?.find(
      (r: ITeamMemberRight) => r.type === RightType.RIGHT_CONSULT_ALL_AGENDAS_AND_FOLDERS
    ),
    RAAC: !!props.teamMember.rights?.find(
      (r: ITeamMemberRight) => r.type === RightType.RIGHT_ASSIGN_APPOINTMENT_TO_COLLABORATOR
    ),
    RUR: !!props.teamMember.rights?.find((r: ITeamMemberRight) => r.type === RightType.RIGHT_UPDATE_RECORD),
    RANR: !!props.teamMember.rights?.find((r: ITeamMemberRight) => r.type === RightType.RIGHT_ADD_NEW_RECORD)
  };

  const methods = useForm<FormValues>({
    defaultValues: defaultValues
  });
  const {
    formState: { errors }
  } = methods;
  const [availability] = useState<ITeamMemberAvailability>(
    props.teamMember.availability ?? defaultTeamMemberAvailability
  );
  const [selectedRights, setSelectedRights] = useState<Array<ITeamMemberRight>>(props.teamMember.rights);
  const [teamMember, setTeamMember] = useState<ITeamMember>(props.teamMember);
  useEffect(() => {
    setTeamMember(props.teamMember);
    setSelectedRights(props.teamMember.rights);
  }, [props.teamMember]);

  useEffect(() => {
    setTeamMember({
      ...teamMember,
      availability: availability
    });
  }, [availability]); //eslint-disable-line

  useEffect(() => {
    setTeamMember({
      ...teamMember,
      rights: selectedRights
    });
  }, [selectedRights]); //eslint-disable-line

  const handleClose = () => {
    setShow(false);
  };

  const submitForm = async (data: FormValues) => {
    let parsedData: ITeamMember = { ...props.teamMember };
    const rights: ITeamMemberRight[] = [];
    !data.RCAF || rights.push({ type: RightType.RIGHT_CONSULT_ALL_AGENDAS_AND_FOLDERS });
    !data.RAAC || rights.push({ type: RightType.RIGHT_ASSIGN_APPOINTMENT_TO_COLLABORATOR });
    !data.RUR || rights.push({ type: RightType.RIGHT_UPDATE_RECORD });
    !data.RANR || rights.push({ type: RightType.RIGHT_ADD_NEW_RECORD });
    parsedData = {
      ...parsedData,
      teamId: props.team.id,
      rights: rights,
      user: {
        ...parsedData.user,
        firstname: data.firstname,
        name: data.name,
        email: data.email,
        phoneNumber: data.phoneNumber,
        userInfos: {
          ...parsedData.user.userInfos,
          activityDone: data.activityDone,
          activityTime: data.activityTime
        }
      }
    };
    actionRequest(parsedData)
      .then(() => {
        setShow(false);
        reloadTeam().then(() => {
          toast.success(formTypeText[type].success);
        });
      })
      .catch(() => {
        toast.error(formTypeText[type].error);
      });
  };
  const onSubmit: SubmitHandler<FormValues> = (data: FormValues) => submitForm(data);

  return (
    <Modal show={show} onHide={handleClose} className="modal-team">
      <div className="p-4">
        <div>
          <h2 className="fw-bold" style={{ fontSize: '24px' }}>
            {formTypeText[type].title}
          </h2>
          <p className="p-order">{formTypeText[type].subtitle}</p>
        </div>
        <h3 style={{ fontSize: '19px', color: '#000d5b' }} className="mt-5">
          Coordonnées de votre collaborateur
        </h3>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Row className="mt-3">
            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Prénom</label>
              <input
                className="w-100 add-prop-input"
                type="text"
                {...methods.register('firstname', { required: true, pattern: /^\D+$/ })}
              />
              {errors.firstname && <span>Veuillez entrer un prénom conforme</span>}
            </Col>
            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Nom</label>
              <input
                className="w-100 add-prop-input"
                type="text"
                {...methods.register('name', { required: true, pattern: /^\D+$/ })}
              />
              {errors.name && <span>Veuillez entrer un nom conforme</span>}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Email</label>

              <input
                className="w-100 add-prop-input"
                type="text"
                {...methods.register('email', { required: true, pattern: /\S+@\S+\.\S+/ })}
              />
              {errors.email && <span>Veuillez entrer une adresse email conforme</span>}
            </Col>
            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Téléphone</label>
              <input
                className="w-100 add-prop-input"
                type="text"
                {...methods.register('phoneNumber', {
                  required: true,
                  pattern: /^(?:\+33|0) *[1-9](?: *[0-9]{2}){4}$/
                })}
              />
              {errors.phoneNumber && <span>Veuillez entrer un numéro de téléphone conforme</span>}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Fonction</label>
              <div className="select-creatable-team-member-form">
                <SelectCreatableHookForm
                  control={methods.control}
                  creatable={false}
                  options={props.referentials[ReferentialType.USER_INFO_ACTIVITY_DONE].data}
                  name={'activityDone'}
                  getValue={() => {}}
                  isMulti={false}
                  label={' '}
                  defaultValue={teamMember.user.userInfos.activityDone}
                />
              </div>
            </Col>

            <Col md={12} lg={6}>
              <label className="w-100 add-prop-label ms-2">Durée de la fonction</label>
              <div className="select-creatable-team-member-form">
                <SelectCreatableHookForm
                  control={methods.control}
                  creatable={false}
                  options={props.referentials[ReferentialType.USER_INFO_ACTIVITY_TIME].data}
                  name={'activityTime'}
                  getValue={() => {}}
                  isMulti={false}
                  label={' '}
                  defaultValue={teamMember.user.userInfos.activityTime}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12} lg={6}>
              <h3 style={{ fontSize: '19px', color: '#000d5b' }} className="mt-5 mb-3">
                Droits de votre collaborateur
              </h3>
              <Form.Check
                className="checkbox-team mb-2"
                type="checkbox"
                {...methods.register('RCAF')}
                label="Consulter tous les agendas et tous les dossiers"
              />
              <Form.Check
                className="checkbox-team mb-2"
                type="checkbox"
                {...methods.register('RAAC')}
                label="Assigner un rendez-vous à un collaborateur"
              />
              <Form.Check
                className="checkbox-team mb-2"
                type="checkbox"
                {...methods.register('RUR')}
                label="Modifier la fiche d’un bien"
              />
              <Form.Check
                className="checkbox-team mb-2"
                type="checkbox"
                {...methods.register('RANR')}
                label="Ajouter un nouveau bien immobilier"
              />
            </Col>
            {/*  <Col md={12} lg={6}>
                            {
                                type === TeamMemberFormType.UPDATE &&
                                <div>
                                    <h3 style={{fontSize: "19px", color: "#000d5b"}} className="mt-5">Disponibilité</h3>
                                    <UpdateAvailability
                                        availability={availability}
                                        errors={errors2}
                                        setAvailability={setAvailability}
                                        team={team}
                                    />
                                </div>
                            }
                        </Col> */}
          </Row>
          <div className="d-sm-flex mt-2 justify-content-between d-none ">
            <Button variant="outline-secondary" onClick={handleClose}>
              Annuler
            </Button>
            {/* <Button className='ml-auto' onClick={handleSubmit}>Ajouter un collaborateur</Button> */}
            <input className="ml-auto" type="submit" value="Ajouter un collaborateur" />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ModalTeamMemberForm;
